<template>

    <input-holder :inlinerows="inlinerows" :inlinerowclasses="inlinerowclasses" :label="label" :inlineLabelClass="inlineLabelClass" :inlineInputClass="inlineInputClass" error="">
      <b-form-radio v-model="status" :class="radioClass" :name="name" @change="onInput" :value="value">
        <span v-if="defaultText" class="checkbox-default-text"> {{ defaultText }} </span>
        <slot> </slot>
        <br v-if="secondaryText" />
        <span v-if="secondaryText" class="checkbox-secondary-text"> {{ secondaryText }} </span>
        <small class="input-error" v-if="error">{{ error }}</small>
      </b-form-radio>
    </input-holder>

  </template>
  
  <script>
  import "../../assets/scss/checkbox.scss";
  
  import InputHolder from "./InputHolder.vue";
  
  export default {
    name: "my-radio",
    data() {
      return {
        status: "not_accepted",
      };
    },
    components: {
      InputHolder,
    },
    methods: {
      onInput() {
        this.$emit("input", this.value);
      },
    },
    props: {
      inlinerows: {
        // type: Boolean,
        default: false,
      },
      inlinerowclasses: {
        default: "mb-3",
      },
      label: {
        type: String,
      },
      inlineLabelClass: {
        default: "col-sm-2",
      },
      inlineInputClass: {
        default: "col-sm-10",
      },
      error: {
        type: String,
        default: "",
      },
  
      id: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      readOnly: {
        default: false,
      },
      defaultText: {
        default: "",
      },
      secondaryText: {
        default: "",
      },
      value: {
        type: String,
        required: true,
      },
      radioClass: {
        default: "radio-branded",
      },
    },
  };
  </script>
  